module.exports = __webpack_public_path__ + "img/checkApp2.ff294789.png";